import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon } from '@livable/saas-react-components';
import { Button, Divider, Menu } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DeactivateMemberModal } from 'src/pages/TeamSettingsPage/DeactivateMemberModal';
// import TransferRoleModal from 'src/pages/TeamSettingsPage/TransferRoleModal';
// import ViewPropertyAccessModal from 'src/pages/TeamSettingsPage/ViewPropertyAccessModal';
import useStyles from './styles';
import { USER_ROLES_BY_NAME } from 'src/constants/userSetting';
export default function TeamMemberMenu(_ref) {
  let member = _ref.member,
    handleEditModal = _ref.handleEditModal,
    handleResendInvite = _ref.handleResendInvite,
    handleDeactivateSuccess = _ref.handleDeactivateSuccess;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const memberIsPending = !member.emailConfirmed;
  // const memberIsActive = member.emailConfirmed === 'active';
  // const memberIsReinvited = member.status === 're-invite';
  // const memberIsInactive = member.status === 'inactive';
  // const memberIsSuperAdmin = member.roleValue === 'super-admin';

  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDeactivateModal = _useState2[0],
    setIsDeactivateModal = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    anchorEl = _useState4[0],
    setAnchorEl = _useState4[1];
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DeactivateMemberModal, {
    member: member,
    isOpen: isDeactivateModal,
    handleDeactivateSuccess: handleDeactivateSuccess,
    handleClose: () => {
      setIsDeactivateModal(false);
    }
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    id: "action-menu-trigger",
    "aria-controls": "action-menu",
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    "aria-label": "team member menu",
    onClick: handleClick,
    state: open ? 'active' : undefined,
    className: classes.menuTrigger,
    'custom-attribute': '843-team-settings-page-my-team-dash-menu'
  }, /*#__PURE__*/React.createElement("span", null, t('team_page.settings')), /*#__PURE__*/React.createElement(Icon, {
    type: "triangle-down"
  })), /*#__PURE__*/React.createElement(Menu, {
    type: "action-menu",
    id: "action-menu",
    MenuListProps: {
      'aria-labelledby': 'action-menu-trigger'
    },
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    elevation: 0,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => {
      handleClose();
      handleEditModal(member.accountId);
    },
    'custom-attribute': '844-team-settings-page-my-team-dash-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), t('team_page.edit_details')), memberIsPending && /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => {
      handleClose();
      handleResendInvite(member.accountId);
    },
    'custom-attribute': '845-team-settings-page-my-team-dash-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "mail"
  }), t('team_page.resend_invite')), member.userRole !== USER_ROLES_BY_NAME.PropertyManagerAccountHolder && /*#__PURE__*/React.createElement(Divider, null), member.userRole !== USER_ROLES_BY_NAME.PropertyManagerAccountHolder && /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => {
      handleClose();
      setIsDeactivateModal(true);
    },
    'custom-attribute': '846-team-settings-page-my-team-dash-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "user-deactivate"
  }), t('team_page.deactivate_member'))));
}